(function () {
  'use strict';

  var COVER_WIDTH = 981;
  var COVER_HEIGHT = 733;
  var SCRATCH_RADIUS = 52;
  var REVEAL_THRESHOLD = 50;

  function initLaborDayScratch(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const customerId = section.dataset.customerId || '';
    const apiBaseUrl = (section.dataset.apiBase || 'https://tl.adshopify.com').replace(/\/$/, '');
    const loginUrl = section.dataset.loginUrl || '/account/login';
    const storefrontLoginUrl = section.dataset.storefrontLoginUrl || '';
    const registerUrl = section.dataset.registerUrl || '/account/register';
    const coverUrl = section.dataset.coverUrl || '';
    const isLoggedIn = Boolean(customerId);
    const SOURCE_STORAGE_KEY = 'labor_day_scratch_source';

    function captureTrafficSource() {
      try {
        var params = new URLSearchParams(window.location.search);
        var raw =
          params.get('utm_source') ||
          params.get('scratch_source') ||
          params.get('source') ||
          '';
        if (raw) {
          sessionStorage.setItem(SOURCE_STORAGE_KEY, raw);
          return raw;
        }
        return sessionStorage.getItem(SOURCE_STORAGE_KEY) || '';
      } catch (e) {
        return '';
      }
    }

    var trafficSource = captureTrafficSource();

    const canvas = section.querySelector('[data-scratch-canvas]');
    const card = section.querySelector('[data-scratch-card]');
    const resultEl = section.querySelector('[data-scratch-result]');
    const endedEl = section.querySelector('[data-scratch-ended]');
    const loginModal = section.querySelector('[data-scratch-login-modal]');

    if (!canvas || !card || !resultEl) return;

    if (!isLoggedIn) {
      canvas.classList.add('ld-scratch__canvas--guest');
    }

    const ctx = canvas.getContext('2d');
    const coverImage = new Image();
    let coverReady = false;
    let prizeData = null;
    let drawing = false;
    let apiRequested = false;
    let revealed = false;
    let scratchDisabled = false;

    coverImage.crossOrigin = 'anonymous';
    coverImage.onload = function () {
      coverReady = true;
      drawCover();
    };
    coverImage.onerror = function () {
      coverReady = false;
      drawCover();
    };
    if (coverUrl) coverImage.src = coverUrl;

    function getLoginReturnPath() {
      return window.location.pathname + window.location.search + window.location.hash;
    }

    function redirectToLogin() {
      const encodedReturn = encodeURIComponent(getLoginReturnPath());

      if (storefrontLoginUrl) {
        window.location.href = '/customer_authentication/login?return_to=' + encodedReturn;
        return;
      }

      const separator = loginUrl.indexOf('?') >= 0 ? '&' : '?';
      window.location.href = loginUrl + separator + 'return_url=' + encodedReturn;
    }

    function getRegisterUrl() {
      const encodedReturn = encodeURIComponent(getLoginReturnPath());
      const separator = registerUrl.indexOf('?') >= 0 ? '&' : '?';
      return registerUrl + separator + 'return_url=' + encodedReturn;
    }

    function showLoginModal() {
      if (!loginModal) {
        redirectToLogin();
        return;
      }
      loginModal.hidden = false;
      loginModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function hideLoginModal() {
      if (!loginModal) return;
      loginModal.hidden = true;
      loginModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function stopWiggle() {
      card.classList.remove('ld-scratch__ticket--wiggle');
    }

    function drawCover() {
      if (canvas.hidden || revealed) return;

      ctx.globalCompositeOperation = 'source-over';

      if (coverReady) {
        ctx.clearRect(0, 0, COVER_WIDTH, COVER_HEIGHT);
        ctx.drawImage(coverImage, 0, 0, COVER_WIDTH, COVER_HEIGHT);
        return;
      }

      ctx.fillStyle = '#99c5f6';
      ctx.fillRect(0, 0, COVER_WIDTH, COVER_HEIGHT);
    }

    function setCanvasSize() {
      if (canvas.hidden || revealed) return;
      const rect = card.getBoundingClientRect();
      canvas.width = COVER_WIDTH;
      canvas.height = COVER_HEIGHT;
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      drawCover();
    }

    function getScratchedPercent() {
      const pixels = ctx.getImageData(0, 0, COVER_WIDTH, COVER_HEIGHT).data;
      let transparent = 0;
      let total = 0;
      const step = 24;

      for (let i = 3; i < pixels.length; i += 4 * step) {
        total++;
        if (pixels[i] < 128) transparent++;
      }

      return total ? (transparent / total) * 100 : 0;
    }

    function cleanPrizeName(name) {
      if (!name) return '';
      return String(name).replace(/\s*\(Code:\s*[^)]+\)\s*$/i, '').trim();
    }

    function lookupPrizeMeta(prizeKey) {
      if (!prizeKey) return null;
      return section.querySelector('[data-prize-key="' + prizeKey + '"]');
    }

    function highlightWonPrize(prizeKey) {
      section.querySelectorAll('[data-prize-key]').forEach(function (el) {
        el.classList.toggle('is-won', Boolean(prizeKey) && el.dataset.prizeKey === prizeKey);
      });
    }

    function renderResult(data) {
      const title = section.querySelector('[data-result-title]');
      const message = section.querySelector('[data-result-message]');
      const prizeName = section.querySelector('[data-result-prize-name]');
      const prizeImage = section.querySelector('[data-result-prize-image]');
      const prizeWrap = section.querySelector('[data-result-prize-wrap]');
      const matched = lookupPrizeMeta(data.prize_key);
      const displayName = (matched && matched.dataset.prizeTitle) || cleanPrizeName(data.prize_name);
      const matchedImg = matched ? matched.querySelector('[data-prize-image]') : null;

      if (title) title.textContent = 'Congrats!';
      if (message) {
        message.textContent = "You've unlocked an exclusive Labor Day reward!";
      }
      if (prizeName) prizeName.textContent = displayName;

      if (prizeImage) {
        if (matchedImg && matchedImg.getAttribute('src')) {
          prizeImage.src = matchedImg.getAttribute('src');
          prizeImage.alt = displayName;
          prizeImage.hidden = false;
        } else {
          prizeImage.hidden = true;
          prizeImage.removeAttribute('src');
        }
      }

      if (prizeWrap) prizeWrap.hidden = false;
      resultEl.hidden = false;
      if (endedEl) endedEl.hidden = true;
      card.classList.add('is-revealed');
      highlightWonPrize(data.prize_key);
      stopWiggle();
    }

    function finishReveal(immediate) {
      scratchDisabled = true;
      revealed = true;
      stopWiggle();
      card.classList.add('is-revealed');
      ctx.clearRect(0, 0, COVER_WIDTH, COVER_HEIGHT);

      if (immediate) {
        canvas.hidden = true;
        canvas.style.pointerEvents = 'none';
        return;
      }

      canvas.style.opacity = '0';
      canvas.style.pointerEvents = 'none';
      setTimeout(function () {
        canvas.hidden = true;
      }, 350);
    }

    function maybeReveal() {
      if (revealed || !prizeData) return;
      if (getScratchedPercent() >= REVEAL_THRESHOLD) finishReveal(false);
    }

    function requestPrize() {
      if (apiRequested || !isLoggedIn || revealed) return;
      apiRequested = true;

      var scratchUrl =
        apiBaseUrl +
        '/api/labor-day/scratch?user_id=' +
        encodeURIComponent(customerId);
      if (trafficSource) {
        scratchUrl += '&source=' + encodeURIComponent(trafficSource);
      }

      fetch(scratchUrl, {
        method: 'POST'
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (body) {
              throw new Error(body.detail || 'Scratch failed.');
            });
          }
          return res.json();
        })
        .then(function (data) {
          prizeData = data;
          renderResult(data);
        })
        .catch(function (err) {
          apiRequested = false;
          drawCover();
          window.alert(err.message || 'Unable to load reward. Please try again later.');
        });
    }

    function showEnded() {
      scratchDisabled = true;
      revealed = true;
      stopWiggle();
      if (endedEl) endedEl.hidden = false;
      if (resultEl) resultEl.hidden = true;
      if (canvas) {
        canvas.hidden = true;
        canvas.style.pointerEvents = 'none';
      }
    }

    function showAlreadyScratched(status) {
      prizeData = {
        prize_key: status.prize_key,
        prize_name: status.prize_name,
        is_winner: true
      };
      apiRequested = true;
      renderResult(prizeData);
      finishReveal(true);
    }

    function loadStatus() {
      if (!isLoggedIn) return;

      fetch(apiBaseUrl + '/api/labor-day/scratch/status?user_id=' + encodeURIComponent(customerId))
        .then(function (res) {
          if (!res.ok) throw new Error('Status request failed: ' + res.status);
          return res.json();
        })
        .then(function (status) {
          if (status.already_scratched) {
            showAlreadyScratched(status);
            return;
          }

          if (status.event_active === false) {
            showEnded();
          }
        })
        .catch(function (err) {
          console.warn('[labor-day-scratch] status failed, allowing scratch attempt:', err);
        });
    }

    function pointerPos(e) {
      const rect = canvas.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      return {
        x: ((clientX - rect.left) / rect.width) * COVER_WIDTH,
        y: ((clientY - rect.top) / rect.height) * COVER_HEIGHT
      };
    }

    function scratchAt(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, SCRATCH_RADIUS, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
    }

    function onStart(e) {
      if (scratchDisabled || revealed) return;
      stopWiggle();
      if (!isLoggedIn) {
        showLoginModal();
        return;
      }
      e.preventDefault();
      drawing = true;
      requestPrize();
      const pos = pointerPos(e);
      scratchAt(pos.x, pos.y);
      maybeReveal();
    }

    function onMove(e) {
      if (!drawing || scratchDisabled || revealed || !isLoggedIn) return;
      e.preventDefault();
      const pos = pointerPos(e);
      scratchAt(pos.x, pos.y);
      maybeReveal();
    }

    function onEnd() {
      drawing = false;
      maybeReveal();
    }

    canvas.addEventListener('mousedown', onStart);
    canvas.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onEnd);
    canvas.addEventListener('touchstart', onStart, { passive: false });
    canvas.addEventListener('touchmove', onMove, { passive: false });
    canvas.addEventListener('touchend', onEnd);

    section.querySelectorAll('[data-scratch-login-btn]').forEach(function (btn) {
      btn.addEventListener('click', redirectToLogin);
    });

    const signupLink = section.querySelector('.ld-scratch__login-modal-signup a');
    if (signupLink) signupLink.href = getRegisterUrl();

    section.querySelectorAll('[data-scratch-login-close]').forEach(function (el) {
      el.addEventListener('click', hideLoginModal);
    });

    loginModal?.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideLoginModal();
    });

    setCanvasSize();
    window.addEventListener('resize', setCanvasSize);
    loadStatus();
  }

  function boot() {
    document.querySelectorAll('[data-labor-day-scratch]').forEach(initLaborDayScratch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-labor-day-scratch]') || event.target;
    if (section.matches && section.matches('[data-labor-day-scratch]')) {
      section.dataset.initialized = 'false';
      initLaborDayScratch(section);
    }
  });
})();
